import React from "react";
import { StyledFooter } from "../styles/styledComponents";
import { ReactComponent as LogoPlannja } from "../assets/images/plannja_logo_white.svg";
import piriLogo from "../assets/images/Piristeel_logo.png";
import { piristeelTheme, plannjaTheme, ruukkiTheme } from "../styles/themes";
import { useParams } from "react-router-dom";

type FooterProps = {
  theme?: any;
};

const Footer = (props: FooterProps) => {
  const { theme } = props;
  const { languageId = "SE" } = useParams();
  
  return (
    <StyledFooter>
      {theme === plannjaTheme && languageId.toUpperCase() === "SE" && (
        <>
          <div>
            <h4>Plannja AB</h4>
            <p>Ringvägen</p>
            <p>577 76 Järnforsen</p>
            <p>Telefon: 010-516 10 00</p>
            <p>marknad@plannja.se</p>
            <p>webmaster@plannja.se</p>
          </div>
          <div>
            <LogoPlannja width="300px" fill="white" />
          </div>
        </>
      )}
      {theme === plannjaTheme && languageId.toUpperCase() === "NO" && (
          <>
            <div>
              <h4>Plannja AS</h4>
              <p>Tellingveien 15</p>
              <p>1081 Oslo</p>
              <p>&nbsp;</p>
              <p>Postboks 6753</p>
              <p>0609 Oslo</p>
              <p>&nbsp;</p>
              <p>Tlf: 23 28 85 00</p>
              <p>oslo@plannja.no</p>
              <p>eservice@plannja.no</p>
            </div>
            <div>
              <LogoPlannja width="300px" fill="white" />
            </div>
          </>
      )}      
      {theme === piristeelTheme && (
        <>
          <div></div>
          <div>
            <img width="300px" alt="Piristeel logo" src={piriLogo} />
          </div>
        </>
      )}
      {theme === ruukkiTheme && (
        <>
          <div></div>
          <div>
            <img width="300px" alt="" src="" />
          </div>
        </>
      )}
    </StyledFooter>
  );
};

export default Footer;
